import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

import {
    AccessorialData,
    AccessorialsState,
    AccessorialState,
    CarrierShipViaAccesorial,
    EditAccessorialState,
} from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

const initialState: AccessorialsState = {
    isLoading: false,
    isLoadingOverlay: false,
    accessorials: null,
    selectedAccessorialIds: {},
    selectFilter: "",
    selectFilterText: "",
    pagination: null,
    isAllAccessorialSelected: false,
    carrierShipAccessorial: null,
};
type SearchFilterKeys = "selectFilter" | "selectFilterText";
type SearchFilterActionType = {
    key: SearchFilterKeys;
    value: string;
};
export const reducer = {
    "Custom/Accessorials/BeginLoad": (draft: Draft<AccessorialsState>) => {
        draft.isLoading = true;
    },
    "Custom/Accessorials/ShowOverlay": (draft: Draft<AccessorialsState>) => {
        draft.isLoadingOverlay = true;
    },
    "Custom/Accessorials/HideOverlay": (draft: Draft<AccessorialsState>) => {
        draft.isLoadingOverlay = false;
    },
    "Custom/Accessorials/CompleteLoad": (draft: Draft<AccessorialsState>, action: AccessorialState) => {
        draft.isLoading = false;
        draft.accessorials = action.accessorials.accessorials;
        draft.pagination = action.accessorials.pagination;
    },
    "Custom/Accessorials/FailedToLoadAccessorials": (draft: Draft<AccessorialsState>) => {
        draft.isLoading = false;
        draft.accessorials = null;
    },
    "Custom/Accessorials/ToggleSelectedAccessorials": (draft: Draft<AccessorialsState>, action: { ids: string[] }) => {
        for (const id of action.ids) {
            if (draft.selectedAccessorialIds[id]) {
                delete draft.selectedAccessorialIds[id];
            } else {
                draft.selectedAccessorialIds[id] = true;
            }
        }
    },
    "Custom/Accessorials/ClearSelectedAccessorials": (draft: Draft<AccessorialsState>) => {
        draft.selectedAccessorialIds = {};
    },
    "Custom/Accessorials/SetSearchFilter": (
        draft: Draft<AccessorialsState>,
        { filters }: { filters: SearchFilterActionType },
    ) => {
        draft[filters.key] = filters.value;
    },
    "Custom/Accessorials/SelectedAllAccessorials": (
        draft: Draft<AccessorialsState>,
        action: { isAllAccessorialSelected: boolean },
    ) => {
        draft.isAllAccessorialSelected = action.isAllAccessorialSelected;
    },
    "Custom/CarrierShipViaAccessorials/CompleteLoad": (
        draft: Draft<AccessorialsState>,
        action: { accessorials: CarrierShipViaAccesorial[] },
    ) => {
        draft.isLoading = false;
        draft.carrierShipAccessorial = action.accessorials;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
